"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adMetricsTimeseriesResponseSchema = exports.adMetricsDataPointSchema = exports.adMetricsTimeseriesRequestSchema = exports.googleAdMetricSchema = exports.facebookAdMetricSchema = exports.GOOGLE_AD_METRICS = exports.FACEBOOK_AD_METRICS = exports.timeGranularitySchema = exports.entityTypeSchema = exports.adPlatformSchema = void 0;
exports.getAvailableMetrics = getAvailableMetrics;
exports.isValidMetricForPlatform = isValidMetricForPlatform;
var zod_1 = require("zod");
exports.adPlatformSchema = zod_1.z.enum(['facebook', 'google']);
exports.entityTypeSchema = zod_1.z.enum(['campaign', 'adset', 'ad']);
exports.timeGranularitySchema = zod_1.z.enum(['daily', 'weekly', 'monthly']);
exports.FACEBOOK_AD_METRICS = [
    'impressions',
    'clicks',
    'spend',
    'cpm',
    'cpc',
    'ctr',
    'conversions',
    'conversion_rate',
];
exports.GOOGLE_AD_METRICS = [
    'impressions',
    'clicks',
    'cost',
    'cpm',
    'cpc',
    'ctr',
    'conversions',
    'conversion_rate',
    'impression_share',
];
exports.facebookAdMetricSchema = zod_1.z.enum(exports.FACEBOOK_AD_METRICS);
exports.googleAdMetricSchema = zod_1.z.enum(exports.GOOGLE_AD_METRICS);
exports.adMetricsTimeseriesRequestSchema = zod_1.z
    .object({
    entityId: zod_1.z.string().min(1, 'Entity ID is required'),
    entityType: exports.entityTypeSchema,
    platform: exports.adPlatformSchema,
    metric: zod_1.z.string().min(1, 'Metric is required'),
    startDate: zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid date format (YYYY-MM-DD)'),
    endDate: zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid date format (YYYY-MM-DD)'),
    granularity: exports.timeGranularitySchema,
})
    .refine(function (data) {
    var start = new Date(data.startDate);
    var end = new Date(data.endDate);
    return start <= end;
}, { message: 'Start date must be before or equal to end date' })
    .refine(function (data) {
    var start = new Date(data.startDate);
    var end = new Date(data.endDate);
    var diffDays = Math.ceil((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
    // Calculate approximate number of data points based on granularity
    var maxDays;
    switch (data.granularity) {
        case 'daily':
            maxDays = 50; // 50 days
            break;
        case 'weekly':
            maxDays = 50 * 7; // 50 weeks = 350 days
            break;
        case 'monthly':
            maxDays = 50 * 30; // 50 months = ~1500 days
            break;
    }
    return diffDays <= maxDays;
}, function (data) {
    var maxPeriods = {
        daily: '50 days',
        weekly: '50 weeks',
        monthly: '50 months',
    };
    return {
        message: "Date range cannot exceed ".concat(maxPeriods[data.granularity], " for ").concat(data.granularity, " granularity (max 50 data points)"),
    };
});
exports.adMetricsDataPointSchema = zod_1.z.object({
    date: zod_1.z.string(),
    value: zod_1.z.number(),
});
exports.adMetricsTimeseriesResponseSchema = zod_1.z.object({
    dataPoints: zod_1.z.array(exports.adMetricsDataPointSchema),
    metric: zod_1.z.string(),
    entityId: zod_1.z.string(),
    entityName: zod_1.z.string(),
    entityType: exports.entityTypeSchema,
    platform: exports.adPlatformSchema,
    granularity: exports.timeGranularitySchema,
    startDate: zod_1.z.string(),
    endDate: zod_1.z.string(),
});
function getAvailableMetrics(platform) {
    return platform === 'facebook' ? exports.FACEBOOK_AD_METRICS : exports.GOOGLE_AD_METRICS;
}
function isValidMetricForPlatform(metric, platform) {
    var availableMetrics = getAvailableMetrics(platform);
    return availableMetrics.includes(metric);
}
